import { render } from "./QuickLocations.vue?vue&type=template&id=cb74f0ea"
import script from "./QuickLocations.vue?vue&type=script&lang=js"
export * from "./QuickLocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__